import { render, staticRenderFns } from "./CopyStakeUserBlacklistModal.vue?vue&type=template&id=a8089760&scoped=true&lang=pug"
import script from "./CopyStakeUserBlacklistModal.vue?vue&type=script&lang=ts"
export * from "./CopyStakeUserBlacklistModal.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeUserBlacklistModal.vue?vue&type=style&index=0&id=a8089760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8089760",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
